import { z } from 'zod';

import { client } from '~shared/api';

import { SectionDto, SectionDtoScheme } from '../model/dto.ts';

/**
 * Список участков
 */
export async function fetchListSections(search?: string) {
	const params = new URLSearchParams({});
	if (search) {
		params.set('search', search.trim());
	}

	const data = await client.get(`/section?${params.toString()}`);
	return z.array(SectionDtoScheme).parse(data);
}

export async function fetchAvailableSection() {
	const data = await client.get('/section/available');
	return z.array(SectionDtoScheme).parse(data);
}

export async function getSection(id: number) {
	const data = await client.get(`/section/${id}`);
	return SectionDtoScheme.parse(data);
}

export async function saveSection(section: Partial<SectionDto>, user_ids: number[]) {
	return SectionDtoScheme.parse(await client.post('/section', { section, user_ids }));
}

export async function removeSection(id: number) {
	await client.del(`/section/${id}`);
}

export async function saveAllAllowed(id: number, value: boolean) {
	await client.post(`/section/allowed/${id}`, { value });
}
